import { PDFViewer } from '@react-pdf/renderer';
import React, { useEffect, useRef, useState } from 'react'
import { OrderPurcharse } from './OrderPurcharse';
import { useDispatch, useSelector } from 'react-redux';
import { loadDetailRequest } from '../../../app/store/requests/thunk';

export const M_Document = ({ detailRequest, detailItems, onClose, closeOnEscape = true, closeOnBackdrop = true }) => {



    // console.log(detailRequest);

    const [isVisible, setIsVisible] = useState(false);
    //  Comportamiento de clic fuera de modal se cierra
    const dialogRef = useRef(null);

    // Fade-in al montar
    useEffect(() => {
        setTimeout(() => setIsVisible(true), 10);
    }, []);

    // Cerrar con Escape si está permitido
    useEffect(() => {
        if (!closeOnEscape) return;

        const handleKeyDown = (e) => {
            if (e.key === "Escape") handleClose();
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [closeOnEscape]);

    // Cerrar con clic fuera si está permitido
    const handleBackdropClick = (e) => {
        if (!closeOnBackdrop) return;
        if (dialogRef.current && !dialogRef.current.contains(e.target)) {
            handleClose();
        }
    };

    // Animación al cerrar
    const handleClose = () => {
        setMostrarPDF(false); // limpia si se cierra el modal
        setIsVisible(false);
        setTimeout(onClose, 250); // espera la animación
    };

    const [pdfKey, setPdfKey] = useState(0);
    const [mostrarPDF, setMostrarPDF] = useState(false);

    const closeModal = () => {
        // dispatch(clearStoreCashOutDetail());

    }

    const generarPDF = () => {
        setMostrarPDF(false);
        setTimeout(() => {
            setPdfKey(prev => prev + 1);
            setMostrarPDF(true);
        }, 100);
    };

    useEffect(() => {
        generarPDF();
    }, []);


    return (
        <div className={`modal d-block custom-backdrop ${isVisible ? "show" : ""}`} onClick={handleBackdropClick}>
            <div ref={dialogRef} className={`modal-dialog modal-lg custom-modal-animate ${isVisible ? "show" : ""}`}>
                <div className="modal-content" style={{ backgroundColor: "#ffffff" }}>
                    <div className="modal-header">
                        <h5 className="modal-title fw-bold">Vista previa</h5>
                        <button type="button" className="btn-close" onClick={handleClose}></button>
                    </div>
                    <div className="modal-body row pdfViewer">
                        {
                            (mostrarPDF) && (
                                <PDFViewer key={pdfKey}>
                                    <OrderPurcharse detailRequest={detailRequest} detailItems={detailItems} />
                                </PDFViewer>
                            )
                        }

                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-outline-dark" onClick={handleClose}>
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
